const routes = [
    {
        name: 'Home',
        path: '/',
        component: 'HomePage'
    },
    {
        name: 'HireMe',
        path: '/portfolio',
        component: 'HireMe'
    },
    {
        name: 'Blog',
        path: '/writing',
        component: 'BlogProjects'
    },
    {
        name: 'BlogPost',
        path: '/writing/:slug',
        component: 'BlogProjectsSingle',
        meta: { keep: false }
    },
    {
        name: 'Mo',
        path: '/bmo',
        component: 'Mo',
    },
    {
        name: 'LostAndFound',
        path: '/:catchAll(.*)*',
        component: 'LostAndFound',
        meta: { code: 404 }
    },
]

export default routes
